<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Maximize" class="d-icon d-icon--maximize" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 1a.5.5 0 0 0 0 1h1.793L6.647 4.647a.5.5 0 0 0 .707.707L10 2.707V4.5a.5.5 0 1 0 1 0v-3a.5.5 0 0 0-.5-.5h-3ZM2 7.5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 .5.5h3a.5.5 0 1 0 0-1H2.707l2.647-2.646a.5.5 0 0 0-.707-.707L2 9.293V7.5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMaximize',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
